export default __webpack_public_path__ + "static/media/ncc_logo_big.7b922f7a.png";